const socialListeningRoute = [
  {
    path: "/:appId/social-listening/mention",
    name: "social-listening.social-analytics.mention",
    component: () => import("@/views/social-analytics/pages/MentionMain.vue"),
    meta: { title: "Social Analytics | Mention" },
  },
  {
    path: "/:appId/social-analytics/comment",
    name: "social-listening.social-analytics.comment",
    component: () => import("@/views/omni-messaging/comment/CommentPage.vue"),
    meta: { title: "Social Analytics | Comment" },
  },
  {
    path: "/:appId/social-analytics/google-review",
    name: "social-listening.customer-review.google-review",
    component: () => import("@/views/social-listening/pages/GoogleReview.vue"),
    meta: { title: "Social Listening - Google Review" },
  },

  {
    path: "/:appId/social-listening/overview",
    name: "social-listening.listening-insights.overview-listening",
    component: () => import("@/views/social-listening/pages/OverviewPage.vue"),
    meta: { title: "Social Listening" },
  },
  {
    path: "/:appId/social-listening/comparation",
    name: "social-listening.listening-insights.comparations",
    component: () =>
      import("@/views/social-listening/pages/ComparationPage.vue"),
    meta: { title: "Social Listening" },
  },
  {
    path: "/:appId/social-listening/topic-list",
    name: "social-listening.listening-insights.topic-list",
    component: () => import("@/views/social-listening/pages/TopicListPage.vue"),
    meta: { title: "Social Listening" },
  },
];

export default socialListeningRoute;
